// ローカル開発時の teras-backend 接続ポート。複数環境の同時起動でポートが衝突する
// 場合は .env.local に API_PORT を指定して上書きする（teras-backend 側の WEB_PORT と
// 合わせる）。未指定時はデフォルトの 13000 を使う。
const DEV_API_PORT = process.env.API_PORT || '13000';

export const API_BASE =
  process.env.NODE_ENV === 'development' ? `http://localhost:${DEV_API_PORT}/api/v1` : '/api/v1';

export const CREDENTIALS = process.env.NODE_ENV === 'development' ? 'include' : 'same-origin';

export const POST_HEADERS = (xCSRFToken: string) => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    'X-CSRF-TOKEN': xCSRFToken,
  };
};
